 <template>
  <div>
      <div class="header-item">
        <div class="open-site-header">
      <div data-aspm="c-menu-area" data-aspm-expo="" class="open-menu-area ">
        <div class="antLogo">
          <a href="https://open.alipay.com" seed="antLogo-link" smartracker="on">
            <img class="antLogoImg" src="https://gw.alipayobjects.com/zos/bmw-prod/7061fe82-8281-41c2-9f92-86188ced7159.svg" alt="支付宝开放平台">
          </a>
        </div>
      </div>
    </div>
  </div>
    <div class="pay">
      <img
        src="https://zhengxin-pub.cdn.bcebos.com/logopic/a9936a369e82e0c6c42112674a5220e8_fullsize.jpg?x-bce-process=image/resize,m_lfit,w_112"
        alt=""
      />
      <div>支付成功</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.pay {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.pay img{
    width:15vw;
}

.pay div{
    font-size: 4vw;
    font-weight: 800;
    margin-top: 3vh;
}

.header-item .open-site-header {
    -webkit-font-smoothing: antialiased;
    height: 60px;
    font-family: Tahoma, arial, "Hiragino Sans GB", "Microsoft Yahei";
    background: #151A28;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.antLogo a {
    display: block;
    font-size: 0;
    height: 58px;
    line-height: 58px;
    margin-right: 20px;
}

.antLogoImg {
    width: 140px;
    height: 20px;
    vertical-align: middle;
}
</style>
